/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { t } from '../../providers';

const ActionButton = ({ menuItems, actionButtonId = 'actionButton', className = '', appId = '', requestNumber = '' }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const handleClick = (event) => {
        setMenuIsOpen(true);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setMenuIsOpen(false);
        setAnchorEl(null);
    };

    const handleAction = (action) => {
        action();
        handleClose();
    };

    return (
        <>
            <IconButton
                aria-expanded={menuIsOpen}
                disableFocusRipple
                id={actionButtonId}
                className={className}
                aria-label={t('options.list').replace('{requestNumber}', requestNumber)}
                aria-haspopup="true"
                onClick={handleClick}
                aria-controls={`action-btn-menu-${requestNumber}`}>
                <MoreVertIcon aria-hidden="true" focusable="false" />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                role="listbox"
                MenuListProps={{
                    id: `action-btn-menu-${requestNumber}`,
                    'aria-labelledby': actionButtonId,
                    style: { display: menuIsOpen ? 'block' : 'none' },
                }}>
                {menuItems
                    .filter((menuItem) => typeof menuItem === 'object') // display only menuItems that is type of object, with label and action props
                    .map((menuItem, index) => (
                        <MenuItem role="option" id={`${actionButtonId}-option-${index}`} key={index} onClick={() => handleAction(menuItem.action)}>
                            {menuItem.label}
                        </MenuItem>
                    ))}
            </Menu>
        </>
    );
};

export default ActionButton;
